<template>
  <base-button type="submit" class="btn-primary" text="招待" />
</template>

<script>
import BaseButton from "@/views/atoms/BaseButton";

export default {
  name: 'InviteButton',
  components: {
    BaseButton
  },
}
</script>
